import React from 'react';
import { Box } from '@material-ui/core';

type ModalContentProps = {
  className?: string;
  children?: React.ReactNode;
};

export const ModalContent = ({ children, ...props }: ModalContentProps) => (
  <Box padding={3} {...props}>
    {children}
  </Box>
);

export default ModalContent;
